import { motion } from "framer-motion";

export const ease = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 32, className = "", as = "div" }) {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </M>
  );
}

export function ImageReveal({ src, alt, className = "", imgClassName = "" }) {
  return (
    <div className={`overflow-hidden ${className || "relative"}`}>
      <img src={src} alt={alt} loading="lazy" className={`h-full w-full object-cover ${imgClassName}`} />
      <motion.div
        aria-hidden
        className="absolute inset-0 origin-top bg-concrete"
        initial={{ scaleY: 1 }}
        whileInView={{ scaleY: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1.1, ease }}
      />
    </div>
  );
}
